"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketRefundApprovalState = exports.TicketRefundState = exports.TicketItemCodeSource = exports.TicketItemValidationSource = exports.TicketItemValidationStatus = exports.PassValidationPeriod = void 0;
exports.validationStatusLabel = validationStatusLabel;
function validationStatusLabel(status) {
    switch (status) {
        case TicketItemValidationStatus.VALID:
            return 'Use';
        case TicketItemValidationStatus.VALID_SOFT:
            return 'Scan';
        case TicketItemValidationStatus.APP_LOOKUP:
            return 'App Lookup';
        case TicketItemValidationStatus.WEB_LOOKUP:
            return 'Web Lookup';
        case TicketItemValidationStatus.INVALID_USE_LIMIT:
            return 'Use Limit';
        case TicketItemValidationStatus.INVALID_USABILITY:
            return 'Usability';
        case TicketItemValidationStatus.INVALID_SECRET:
            return 'Invalid Code';
        case TicketItemValidationStatus.INVALID_ORGANIZATION:
            return 'Invalid Organization';
        case TicketItemValidationStatus.INVALID_ITEM_ID:
            return 'Invalid Item';
        case TicketItemValidationStatus.INVALID_VOIDED:
            return 'Item Voided';
        case TicketItemValidationStatus.INVALID_REFUNDED:
            return 'Refunded';
        case TicketItemValidationStatus.INVALID_PERIOD_LIMIT:
            return 'Period Limit';
        case TicketItemValidationStatus.INVALID_EVENT_LIMIT:
            return 'Event Limit';
        case TicketItemValidationStatus.INVALID_EVENT_REQUIRED:
            return 'Event Required';
        case TicketItemValidationStatus.INVALID_EVENT_MISMATCH:
            return 'Wrong Event';
        default:
            return status ?? '';
    }
}
var PassValidationPeriod;
(function (PassValidationPeriod) {
    PassValidationPeriod["DAY"] = "DAY";
    PassValidationPeriod["WEEK"] = "WEEK";
    PassValidationPeriod["MONTH"] = "MONTH";
    PassValidationPeriod["YEAR"] = "YEAR";
})(PassValidationPeriod || (exports.PassValidationPeriod = PassValidationPeriod = {}));
var TicketItemValidationStatus;
(function (TicketItemValidationStatus) {
    TicketItemValidationStatus["VALID_SOFT"] = "valid.soft";
    TicketItemValidationStatus["APP_LOOKUP"] = "app.lookup";
    TicketItemValidationStatus["WEB_LOOKUP"] = "web.lookup";
    TicketItemValidationStatus["INVALID_USE_LIMIT"] = "invalid.use_limit";
    TicketItemValidationStatus["INVALID_USABILITY"] = "invalid.usability";
    TicketItemValidationStatus["INVALID_ORGANIZATION"] = "invalid.organization";
    TicketItemValidationStatus["INVALID_SECRET"] = "invalid.secret";
    TicketItemValidationStatus["INVALID_ITEM_ID"] = "invalid.itemId";
    TicketItemValidationStatus["INVALID_VOIDED"] = "invalid.voided";
    TicketItemValidationStatus["INVALID_REFUNDED"] = "invalid.refunded";
    TicketItemValidationStatus["INVALID_PERIOD_LIMIT"] = "invalid.period_limit";
    TicketItemValidationStatus["INVALID_EVENT_LIMIT"] = "invalid.event_limit";
    TicketItemValidationStatus["INVALID_EVENT_REQUIRED"] = "invalid.event_required";
    TicketItemValidationStatus["INVALID_EVENT_MISMATCH"] = "invalid.event_mismatch";
    TicketItemValidationStatus["VALID"] = "valid";
})(TicketItemValidationStatus || (exports.TicketItemValidationStatus = TicketItemValidationStatus = {}));
var TicketItemValidationSource;
(function (TicketItemValidationSource) {
    TicketItemValidationSource["APP"] = "app";
    TicketItemValidationSource["WEB"] = "web";
    /** Marked used through the `create_validation` MCP tool (ENG-4548). */
    TicketItemValidationSource["MCP"] = "mcp";
})(TicketItemValidationSource || (exports.TicketItemValidationSource = TicketItemValidationSource = {}));
var TicketItemCodeSource;
(function (TicketItemCodeSource) {
    TicketItemCodeSource["APPLE_WALLET"] = "aw";
    TicketItemCodeSource["WEB"] = "web";
})(TicketItemCodeSource || (exports.TicketItemCodeSource = TicketItemCodeSource = {}));
var TicketRefundState;
(function (TicketRefundState) {
    TicketRefundState["PENDING"] = "pending";
    TicketRefundState["PROCESSING"] = "processing";
    TicketRefundState["ERROR_REFUNDABLE_AMOUNT"] = "error.refundable_amount";
    TicketRefundState["ERROR_REFUNDABLE_STATE"] = "error.refundable_state";
    TicketRefundState["ERROR_NO_REFUNDABLE_TRANSACTION"] = "error.no_refundable_transaction";
    TicketRefundState["ERROR_REFUND_TRANSACTION_FAILED"] = "error.refund_transaction_failed";
    TicketRefundState["ERROR_UNKNOWN"] = "error.unknown";
    TicketRefundState["SUCCEEDED"] = "succeeded";
})(TicketRefundState || (exports.TicketRefundState = TicketRefundState = {}));
var TicketRefundApprovalState;
(function (TicketRefundApprovalState) {
    TicketRefundApprovalState["REQUESTED"] = "requested";
    TicketRefundApprovalState["APPROVED"] = "approved";
    TicketRefundApprovalState["REJECTED"] = "rejected";
})(TicketRefundApprovalState || (exports.TicketRefundApprovalState = TicketRefundApprovalState = {}));
